/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  UpdateBankAccountRequest,
  UpdateBankAccountResponse,
  BankAccountStatusResponse
 } from '../types';

  //  CorePayeeBankAccountsClient
class CorePayeeBankAccountsClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly updateBankAccount = (payload: UpdateBankAccountRequest): AxiosPromise<UpdateBankAccountResponse> => {
        let url_ = "/api/v1/core/payee/bank_accounts";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getBankAccountStatus = (id: string): AxiosPromise<BankAccountStatusResponse> => {
        let url_ = "/api/v1/core/payee/bank_accounts/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeeBankAccountsClient
  
export const corePayeeBankAccountsClient = new CorePayeeBankAccountsClient(baseClientConstructorProps);
